/* unplugin-vue-components disabled */import { render } from "./OpenQuestion.vue?vue&type=template&id=6c961dba&ts=true"
import script from "./OpenQuestion.vue?vue&type=script&lang=ts"
export * from "./OpenQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__